
import { Component, Input } from '@angular/core';

@Component({
    selector: 'relates-to-tab',
    styles: [
        `
    .pane{
      padding: 1em;
    }
  `
    ],
    template: `
    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
    </div>
  `,
    standalone: false
})
export class TabComponent {
  @Input('tabTitle') title: string;
  @Input() active = false;
}
